import React from 'react';
import ReactDOM from 'react-dom';
import { CookiesProvider } from 'react-cookie';
import Root from './components/Root';
import { Router } from 'react-router-dom';
import * as MBST from 'mb-components';
import ReactNotification from 'react-notifications-component';
import 'styles/notifications.css';

ReactDOM.render(
  <Router history={MBST.history}>
    <ReactNotification />
    <CookiesProvider>
      <MBST.Auth0Provider>
        <Root />
      </MBST.Auth0Provider>
    </CookiesProvider>
  </Router>,
  document.getElementById('root'),
);
